import React, { useState, useEffect } from 'react';
import {
  TextField,
  Button,
  MenuItem,
  Container,
  Typography,
  Box,
} from '@mui/material';
import axios from 'axios';
import SuperAdminLayout from '../../../layouts/SuperAdminLayout';
import { useNavigate } from 'react-router-dom';
import api from './../../../utils/api';

const CreateProduct = () => {
  const [form, setForm] = useState({
    productName: '',
    openingQuantity: '',
    purchaseRate: '',
    primaryUnit: '',
    secondaryUnit: '',
    secondaryQuantity: '',
  });
  const [units, setUnits] = useState([]);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    const user = JSON.parse(localStorage.getItem('user'));
    try {
      await api.post(`/api/products/create`, {
        ...form,
        superAdminId: user.id,
      });
      alert('Product Created');
      navigate('/super-admin/product');
    } catch (err) {
      console.error(err);
      alert('Failed to create product');
    }
  };

  useEffect(() => {
    const fetchUnits = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        const res = await api.get(`/api/units/get-all/${user.id}`);
        setUnits(res.data);
      } catch (err) {
        console.error('Failed to fetch units:', err);
      }
    };

    fetchUnits();
  }, []);

  return (
    <SuperAdminLayout>
      <Container>
        <Typography variant="h5" gutterBottom>
          Create Product
        </Typography>
        <Box
          component="form"
          display="flex"
          flexWrap="wrap"
          gap={2}
          rowGap={2}
          mt={2}
        >
          <TextField
            label="Product Name"
            name="productName"
            value={form.productName}
            onChange={handleChange}
            size="small"
            sx={{ flex: '1 1 calc(33.33% - 16px)', minWidth: 220 }}
          />
          <TextField
            label="Opening Quantity"
            name="openingQuantity"
            type="number"
            value={form.openingQuantity}
            onChange={handleChange}
            size="small"
            sx={{ flex: '1 1 calc(33.33% - 16px)', minWidth: 220 }}
          />
          <TextField
            label="Purchase Rate"
            name="purchaseRate"
            type="number"
            value={form.purchaseRate}
            onChange={handleChange}
            size="small"
            sx={{ flex: '1 1 calc(33.33% - 16px)', minWidth: 220 }}
          />
          <TextField
            select
            label="Primary Unit"
            value={form.primaryUnit}
            onChange={(e) => setForm({ ...form, primaryUnit: e.target.value })}
            size="small"
            sx={{ flex: '1 1 calc(33.33% - 16px)', minWidth: 220 }}
          >
            {units.map((u) => (
              <MenuItem key={u._id} value={u.name}>
                {u.name}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            select
            label="Secondary Unit"
            value={form.secondaryUnit}
            onChange={(e) =>
              setForm({ ...form, secondaryUnit: e.target.value })
            }
            size="small"
            sx={{ flex: '1 1 calc(33.33% - 16px)', minWidth: 220 }}
          >
            {units.map((u) => (
              <MenuItem key={u._id} value={u.name}>
                {u.name}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            label="Secondary Quantity"
            name="secondaryQuantity"
            type="number"
            value={form.secondaryQuantity}
            onChange={handleChange}
            size="small"
            sx={{ flex: '1 1 calc(33.33% - 16px)', minWidth: 220 }}
          />
        </Box>
        <Button variant="contained" onClick={handleSubmit}>
          Save Product
        </Button>
      </Container>
    </SuperAdminLayout>
  );
};

export default CreateProduct;
